<template>
    <div>
        <messageTitle :avatar="message.avatar"
                :nick="nick"
              :isMine="isMine"
              :avatarType="avatar"
              :circular="isCustom"
              :showNick="!(isCustom && isMine)"
              :showAvatar="!(!isCustom && isMine)"
              :size="isCustom ? 'middle' : 'small'">
            <messageBubble
                :isMine="isMine"
                :type="isCustom ? 1 : 2">
                <div class="file-container" @click="download">
                    <van-icon name="description" size="2em" />
                    <div class="file-element">
                        <span class="file-name">{{ fileName }}</span>
                        <span class="file-size">{{ size }}</span>
                    </div>
                </div>
            </messageBubble>
        </messageTitle>
        <downIos :downUrl="fileUrl" v-if="showDown" @cancelDown="cancelDown"></downIos>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import { messageSenderRole, messageIsCustom } from '../../utils';
	import messageTitle from '../messageTitle';
	import messageBubble from '../messageBubble';
    import downIos from '../../components/downIos';
	export default {
		name: "fileElement",
		components: {
			messageTitle,
			messageBubble,
			downIos
		},
		props: {
			payload: {
				type: Object,
				required: true
			},
			message: {
				type: Object,
				required: true
			}
		},
		data () {
		    return {
			    showDown: false
		    }
		},
		computed: {
			...mapState('instantMessaging', ['currentMessageList', 'currentMemberList']),
            ...mapGetters('instantMessaging', ['isCustom', 'isC2C']),
			isMine() {
				return this.message.flow === 'out'
			},
			fileName() {
				return this.payload.fileName
			},
			size() {
				const size = this.payload.fileSize;
				if (size > 1024) {
					if (size / 1024 > 1024) {
						return `${this.toFixed(size / 1024 / 1024)} Mb`
					}
					return `${this.toFixed(size / 1024)} Kb`
				}
				return `${this.toFixed(size)}B`
			},
			fileUrl() {
				return this.payload.fileUrl
			},
			showProgress() {
				return this.$parent.message.status === 'unSend'
			},
			percentage() {
				return Math.floor((this.$parent.message.progress || 0) * 100)
			},
			nick() {
				if (this.isC2C) {
					return `${this.message.nick || `暂无昵称（${this.message.from}）`}`;
				} else {
					return `${this.message.nick}(${messageSenderRole(this.message, this.currentMemberList)})`
				}
			},
			avatar() {
				if (messageIsCustom(this.message, this.currentMemberList)) {
					return 'custom';
				} else {
					return 'staff';
				}
			}
		},
		methods: {
			toFixed(number, precision = 2) {
				return number.toFixed(precision)
			},
			downloadFile() {
				// 浏览器支持fetch则用blob下载，避免浏览器点击a标签，跳转到新页面预览的行为
				if (window.fetch) {
					fetch(this.fileUrl)
						.then(res => res.blob())
						.then(blob => {
							let a = document.createElement('a');
							let url = window.URL.createObjectURL(blob);
							a.href = url;
							a.download = this.fileName;
							a.click()
						})
				} else {
					let a = document.createElement('a');
					a.href = this.fileUrl;
					a.target = '_blank';
					a.download = this.filename;
					a.click()
				}
			},
			download() {
				var u = navigator.userAgent;
				const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
				if (isAndroid) {
					window.location.href = this.fileUrl;
				} else {
					this.showDown = true
				}
			},
			cancelDown(type){
				if(type=='success'){
					this.showDown = false;
					setTimeout(()=>{this.$Toast('复制成功')},1000)
				}else{
					this.showDown = false;
				}
			},
		}
	}
</script>

<style scoped lang="less">
.file-container {
    display: flex;
    align-items: center;
    font-size: 14px;
    position: relative;
    max-width: 200px;
    word-wrap: break-word;
    word-break: break-all;
    color: #1E2226;

    .file-element {
        display: flex;
        flex-direction: column;
        margin-left: 12px;

        .file-size {
            font-size: 12px;
            padding-top: 5px;
            color: #71747A;
        }
    }
}
</style>
